"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _material = require("@mui/material");
var _styles = require("@mui/material/styles");
var _shadows = _interopRequireDefault(require("./shadows"));
var _palette = require("./palette");
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var getTheme = function getTheme(mode, themeToggler) {
  return (0, _material.responsiveFontSizes)((0, _styles.createTheme)({
    palette: mode === 'light' ? _palette.light : _palette.dark,
    shadows: (0, _shadows.default)(mode),
    typography: {
      fontFamily: '"Railway", regular',
      button: {
        textTransform: 'none',
        fontWeight: 'medium'
      }
    },
    zIndex: {
      appBar: 1200,
      drawer: 1300
    },
    components: {
      MuiButton: {
        styleOverrides: {
          root: {
            fontWeight: 400,
            borderRadius: 5,
            paddingTop: 10,
            paddingBottom: 10
          },
          containedSecondary: mode === 'light' ? {
            color: 'white'
          } : {}
        }
      },
      MuiInputBase: {
        styleOverrides: {
          root: {
            borderRadius: 5
          }
        }
      },
      MuiOutlinedInput: {
        styleOverrides: {
          root: {
            borderRadius: 5
          },
          input: {
            borderRadius: 5
          }
        }
      },
      MuiCard: {
        styleOverrides: {
          root: {
            borderRadius: 8
          }
        }
      }
    },
    themeToggler: themeToggler
  }));
};
var _default = getTheme;
exports.default = _default;